import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Home         from './pages/Home';
import AboutPage    from './pages/AboutPage';
import FeaturesPage from './pages/FeaturesPage';
import ServicesPage from './pages/ServicesPage';
import SecurityPage from './pages/SecurityPage';
import WorkflowPage from './pages/WorkflowPage';
import ContactPage  from './pages/ContactPage';
import NotFound     from './pages/NotFound';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/"          element={<Home />} />
        <Route path="/about"     element={<AboutPage />} />
        <Route path="/features"  element={<FeaturesPage />} />
        <Route path="/services"  element={<ServicesPage />} />
        <Route path="/security"  element={<SecurityPage />} />
        <Route path="/workflow"  element={<WorkflowPage />} />
        <Route path="/contact"   element={<ContactPage />} />
        <Route path="*"          element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
